import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import useUpcomingEvents from './queries/useUpcomingEvents';

export default function UpcomingEvents() {
  const upcomingEvents = useUpcomingEvents();

  return (
    <section className='pt-20 pb-8 bg-white'>
      <div className='container mx-auto px-4'>
        <div className='flex flex-wrap justify-center text-center mb-8'>
          <div className='w-full lg:w-6/12 px-4'>
            <h4 className='text-4xl font-semibold leading-normal mt-0 text-orange-500'>
              Upcoming Events
            </h4>
            <div className='flex items-center justify-center'>
              <hr className='my-2 border-gray-400 w-1/2' />
            </div>
          </div>
        </div>
        <div className='flex flex-wrap justify-center'>
          {upcomingEvents.map(event => (
            <div
              className='w-full sm:w-8/12 md:w-6/12 lg:w-4/12 px-4 mb-8'
              key={event.alt}
            >
              <div className='relative flex flex-col min-w-0 break-words bg-white w-full shadow-lg rounded-lg overflow-hidden h-full'>
                <GatsbyImage
                  image={event.src.childImageSharp.gatsbyImageData}
                  className='w-full'
                  alt={event.alt}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
